import { Input, Textarea } from '@/components/ui'
import { formatDate, formatPrice } from '@/utils/formatters'

import { EyeIcon } from '@heroicons/react/24/solid'
import Address from '@/components/Address'
import { Carrousel, Modal } from '@/components/ui'

import { getInterventionStatusLabel, getMaterielStatusLabel, getFacturationStatusLabel } from '@/features/interventions/interventionsSlice'

export default ({ intervention }) => {

  const { isOpen, handleShow, handleHide, dialogRef } = Modal.useModal()

  const DownloadButton = ({title, onClick}) => (
    <button 
      onClick={onClick}
      className="btn btn-xs btn-ghost btn-square p-1 hover:bg-primary-400"
      title={`Voir ${title}`} aria-label={`Voir ${title}`}
    >
      <EyeIcon/>
    </button>
  )

  const InputDisplayFile = ({item, label, name, title}) => {

    const file = item ? item[name] : null

    const handleClick = (e) => {
      e.preventDefault()
      e.stopPropagation()
      window.open(file.url , '_blank')
    }

    return (
      <div className="flex items-center justify-between">
        <Input.Display label={label} 
          className="flex items-center mb-2 w-full max-w-9/10"
          labelClassName="" 
          valueClassName="overflow-hidden max-w-4/5 text-nowrap"
        >
          { file?.filename ?
              file?.url ? 
                <button title={`Voir ${title}`} className="flex cursor-pointer" onClick={handleClick}>
                  <span>{file.filename}</span>
                </button> :
                <span>{file.filename}</span> :
                null
          }
        </Input.Display>
        <div className="flex mb-2 ml-2 mr-4">
          { !!file?.url &&
            <DownloadButton title={title} onClick={handleClick} />
          }
        </div>
      </div>
    )
  }

  return (
  <div className="bg-base-200 p-4">
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">

      <div className="flex flex-col pl-2 space-y-4">

        <div className='flex flex-col space-y-4'>
          <h3 className='font-bold'>Info intervention :</h3>
          <Input.Display label="Prestataire" value={intervention?.prestataire?.nom_complet || ''} />
          <Textarea.Display label="Détail de l'intervention" value={intervention?.details || ''}
            className='flex flex-col items-start'
          />
          { intervention?.materiel_a_fournir?.length > 0 &&
            <Textarea.Display label="Matériel à fournir par le client"
              value={intervention?.materiel_a_fournir || ''}
              className='flex flex-col items-start'
            />
          }
          { intervention?.date_intervention &&
            <Input.Display label="Date de l'intervention" value={formatDate(intervention?.date_intervention || '')} />
          }
        </div>

      </div>
        
      <div className="flex flex-col pl-2 space-y-4">

        { (intervention?.info_rdv?.length > 0 || intervention?.devis) &&
          <div className='flex flex-col space-y-4'>
            <h3 className='font-bold'>Info Devis :</h3>
            { intervention?.info_rdv?.length > 0 &&
                <Input.Display label="Info rdv" value={intervention?.info_rdv || ''} valueClassName="uppercase" />
            }
            { intervention?.devis &&
              <InputDisplayFile label="Devis" title="le devis" item={intervention} name="devis" /> 
            }
          </div>
        }

        <div className='flex flex-col space-y-4'>
          <h3 className='font-bold'>Info facture :</h3>
          { intervention?.montant &&
            <Input.Display label="Montant chantier" value={formatPrice(intervention?.montant || '')} />
          }
          { intervention?.montant_materiel &&
            <Input.Display label="Montant matériel" value={formatPrice(intervention?.montant_materiel || '')} />
          }
          
          { intervention.facture_adresse ?
            <Input.Display label="Entité à facturer" className='flex flex-col'>
              <div>{intervention.facture_adresse?.nom || ''}</div>
              { intervention.facture_adresse?.complement && 
                <div className="uppercase">{intervention.facture_adresse.complement}</div>
              }
              <Address data={intervention?.facture_adresse || {}}/>
            </Input.Display> :
            <Input.Display label="Entité à facturer" />
          }
          
          { intervention?.facture_materiel &&
            <InputDisplayFile label="Facture matériel" title="la facture du matériel" item={intervention} name="facture_materiel" /> 
          }

          { intervention?.facture_acompte &&
            <InputDisplayFile label="Facture acompte" title="la facture d'acompte" item={intervention} name="facture_acompte" /> 
          }

          { intervention?.facture_cloture &&
            <InputDisplayFile label="Facture clôture" title="la facture de clôture" item={intervention} name="facture_cloture" /> 
          }
        </div>
          
      </div>

      <div className="flex flex-col pl-2 space-y-4">
        <div className="flex flex-col space-y-4">
          <h3 className='font-bold'>Statuts :</h3>
            <Input.Display 
              label="Statut de l'intervention" 
              value={intervention?.statut ? 
                getInterventionStatusLabel(intervention.statut) : 
                '' 
              }
            />
            { intervention?.statut_materiel && 
              <Input.Display 
                label="Statut du matériel" 
                value={intervention?.statut_materiel ? 
                  getMaterielStatusLabel(intervention.statut_materiel) : 
                  ''
                } 
                />
            }
            { intervention?.statut_facturation && 
              <Input.Display 
                label="Statut de la facturation" 
                value={intervention?.statut_facturation ?
                  getFacturationStatusLabel(intervention.statut_facturation) : 
                  ''
                } 
              />
            }
        </div>

        { (intervention?.pv_livraison || intervention?.photos?.length > 0) &&
          <div className='flex flex-col space-y-4'>
            <h3 className='font-bold'>Fin d'intervention :</h3>
            { intervention?.pv_livraison &&
              <InputDisplayFile label="PV de livraison" title="le PV de livraison" item={intervention} name="pv_livraison" /> 
            }
            
            { intervention?.photos?.length > 0 &&
              <div className="flex items-center justify-between">
                <Input.Display label="Photos">
                  { intervention?.photos && intervention.photos.length > 0 &&                  
                    <button title={`Voir les photos`} className="flex cursor-pointer" onClick={() => handleShow()}>
                      <span>{`${intervention.photos.length} photo(s)`}</span>
                    </button>
                  }
                </Input.Display>
                <div className="flex mb-2 ml-2 mr-4">
                  { (!!intervention?.photos && intervention.photos.length > 0) &&
                      <DownloadButton title="les photos" onClick={() => handleShow() } />
                  }
                </div>
              </div>
            }

          </div>
        }

      </div>
    </div>

    <Modal
      open={isOpen}
      onClose={handleHide}
      ref={dialogRef}
      backdrop={true}
      className="max-w-full rounded-none"
    >
      <Modal.Header showCloseButton={true} />
      <Modal.Body>
        <Carrousel 
          images={intervention.photos?.map( photo => photo.url )} 
          indicatorType='numbers'
        />
      </Modal.Body>
    </Modal>   
  </div>
  )
}